export var AIAgent;
(function (AIAgent) {
    AIAgent["CLAUDE"] = "Claude";
    AIAgent["CHAT_GPT"] = "ChatGPT";
    AIAgent["MS_COPILOT"] = "MSCopilot";
    AIAgent["OPEN_EVIDENCE"] = "OpenEvidence";
    AIAgent["PERPLEXITY"] = "Perplexity";
})(AIAgent || (AIAgent = {}));
